(ns app.bundle-social.register
  "UI register entries for the bundle.social slice: the accounts page,
   its two modals and the actions of the connect flow."
  (:require [app.bundle-social.page :as page]
            [app.bundle-social.platforms :as platforms]
            [parts.replicant.command :as command]
            [parts.replicant.command-query :as command-query]))

(defn- start-connect!
  "Asks the backend for the OAuth url and sends the browser there. The
   modal stays open, showing \"Opening Facebook...\", until the browser
   leaves; it only closes when the request failed. The platform
   redirects back to the accounts page, or to `return-path`,
   afterwards."
  [{:keys [store action ui/event-handler] :as w}]
  (let [[_ platform business? return-path] action
        cmd (page/connect-command platform business? return-path)]
    (when-not (::page/leaving? @store)
      (swap! store assoc ::page/leaving? true)
      (.then (command-query/issue-command
               (assoc w :action [:data/command cmd {:on-error [[:store/dissoc ::page/leaving?]
                                                                [:ui/modal-close]
                                                                [:ui/show-error]]}]))
             (fn [_]
               (if-let [url (:url (command/get-latest-result @store cmd))]
                 (js/location.assign url)
                 ;; No url: the request failed before the server answered
                 ;; (network, deploy). issue-command swallows that without
                 ;; dispatching on-error, so the modal is closed here.
                 (do
                   (swap! store dissoc ::page/leaving?)
                   (event-handler {} [[:ui/modal-close]
                                      [:ui/show-error]]))))))))

(defn- connect!
  "Facebook first opens the scope modal, asked on every connect since
   the answer differs per page. A platform with a
   `:social-platform/connect-hint` (Snapchat, X, Instagram's fallback) first opens the hint.
   Every other platform goes to its OAuth right away. The optional
   `:return-path` is the page the OAuth returns to (the Instagram
   Accounts page for the fallback connection); the scope modal is
   Facebook's only and returns to the accounts page. `:username` is
   the account the hint asks to log in with, `:account-type` its type,
   which picks a note of the hint (`:account-type-notes`)."
  [{:keys [action ui/event-handler]}]
  (let [[_ platform-id {:keys [return-path username account-type]}] action
        platform (platforms/by-id platform-id)]
    (event-handler {} (cond
                        (:social-platform/business-scope? platform)
                        [[:ui/modal-open
                          :modals/social-account-connect-hint
                          {:platform platform-id
                           :max-width "sm:max-w-lg"}]]

                        (:social-platform/connect-hint platform)
                        [[:ui/modal-open
                          :modals/social-account-platform-hint
                          {:platform platform-id
                           :return-path return-path
                           :username username
                           :account-type account-type
                           :max-width "sm:max-w-lg"}]]

                        :else
                        [[:social-accounts/start-connect platform-id nil return-path]]))))

(defn- forget-team-param!
  "Drops `?team=` from the url, so a reload does not sync the team
   again. Keeps the page the OAuth returned to."
  [_w]
  (js/history.replaceState nil "" js/location.pathname))

(defn- open-accounts-page!
  [_w]
  (js/location.replace page/path))

(defn- sync!
  "Syncs the team the user returns with. When the OAuth shared several
   pages, the page picker opens for the first pending account and the
   `?team=` stays in the url, so a reload opens the picker again.
   `:on-done` are the actions after the sync, by default the accounts
   query of the accounts page."
  [{:keys [store action ui/event-handler] :as w}]
  (let [[_ team-id {:keys [on-done]}] action
        cmd (page/sync-command team-id)]
    (.then (command-query/issue-command
             (assoc w :action [:data/command cmd {:on-error [[:ui/show-error]]}]))
           (fn [_]
             ;; Runs after success and failure alike (issue-command
             ;; dispatches on-error itself); without a result there is
             ;; nothing pending.
             (event-handler {} (or on-done [[:data/query page/accounts-query]]))
             (if-let [pending (first (:social-accounts/pending
                                       (command/get-latest-result @store cmd)))]
               (do
                 (swap! store dissoc ::page/selected-channels ::page/selecting-channel?)
                 (event-handler {} [[:ui/modal-open
                                     :modals/social-account-page-select
                                     {:team-id team-id
                                      :platform (:platform pending)
                                      :channels (:channels pending)
                                      :max-width "sm:max-w-lg"}]]))
               (forget-team-param! w))))))

(defn- select-channels!
  [{:keys [store] :as w}]
  (let [{:keys [team-id platform channels]} (get-in @store [:ui/modal :params])
        channel-ids (filter (page/selected-channels @store channels)
                            (map :channel/id channels))
        cmd (page/set-channel-command team-id platform channel-ids)]
    (when (and (seq channel-ids) (not (::page/selecting-channel? @store)))
      (swap! store assoc ::page/selecting-channel? true)
      (-> (command-query/issue-command
            (assoc w :action [:data/command cmd
                              {:on-success [[:ui/modal-close]
                                            [:social-accounts/forget-team-param]
                                            [:data/query page/accounts-query]]
                               :on-error [[:ui/show-error]]}]))
          (.finally #(swap! store dissoc ::page/selecting-channel?))))))

(def register
  (into [page/page
         page/hint-modal
         page/platform-hint-modal
         page/page-select-modal
         {:ui.action/kind :social-accounts/connect
          :ui.action/handler connect!}
         {:ui.action/kind :social-accounts/start-connect
          :ui.action/handler start-connect!}
         {:ui.action/kind :social-accounts/sync
          :ui.action/handler sync!}
         {:ui.action/kind :social-accounts/select-channels
          :ui.action/handler select-channels!}
         {:ui.action/kind :social-accounts/forget-team-param
          :ui.action/handler forget-team-param!}
         {:ui.action/kind :social-accounts/open-accounts-page
          :ui.action/handler open-accounts-page!}]
        page/former-pages))
